const baseStyle = {
    borderRadius: "md",
    fontWeight: "medium",
    lineHeight: "base",
    whiteSpace: "normal",
    _loading: {
        opacity: 1,
    },
    _disabled: {
        opacity: 1,
    },
};
const variantPrimary = {
    color: "greyscale.100",
    background: "primary.500",
    _hover: {
        background: { md: "primary.600" },
        _disabled: {
            color: "primary.300",
            background: "primary.100",
        },
    },
    _active: {
        background: "primary.700",
    },
    _loading: {
        color: "greyscale.100",
        background: "primary.700",
        _hover: {
            color: "greyscale.100",
            background: "primary.700",
        },
    },
    _disabled: {
        color: "primary.300",
        background: "primary.100",
    },
};
const variantSecondary = {
    color: "primary.500",
    background: "greyscale.100",
    borderColor: "primary.500",
    border: "2px",
    _hover: {
        color: { md: "primary.600" },
        background: { md: "primary.100" },
        _disabled: {
            color: "primary.300",
        },
    },
    _active: {
        color: "primary.700",
        background: "greyscale.100",
    },
    _loading: {
        color: "primary.700",
        _hover: {
            color: "primary.700",
        },
    },
    _disabled: {
        color: "primary.300",
    },
};
const variantPrimaryAlternative = {
    color: "greyscale.100",
    background: "secondary.500",
    _hover: {
        color: { md: "secondary.500" },
        background: { md: "secondary.100" },
        _disabled: {
            color: "secondary.300",
            background: "secondary.100",
        },
    },
    _active: {
        color: "secondary.500",
        background: "secondary.200",
    },
    _loading: {
        color: "secondary.500",
        background: "secondary.200",
        _hover: {
            color: "secondary.500",
            background: "secondary.200",
        },
    },
    _disabled: {
        color: "secondary.300",
        background: "secondary.100",
    },
};
const variantSubtle = {
    color: "primary.500",
    background: "greyscale.100",
    _hover: {
        background: { md: "greyscale.200" },
    },
    _disabled: {
        color: "primary.300",
        _hover: {
            background: "greyscale.100",
        },
    },
    _active: {
        background: "greyscale.300",
    },
    _loading: {
        color: "primary.500",
        background: "greyscale.300",
        _hover: {
            color: "primary.500",
            background: "greyscale.300",
        },
    },
};
const variantDanger = {
    color: "greyscale.100",
    background: "danger.700",
    _hover: {
        background: { md: "danger.800" },
        _disabled: {
            background: "secondary.300",
        },
    },
    _active: {
        background: "danger.900",
    },
    _loading: {
        color: "greyscale.100",
        background: "danger.900",
        _hover: {
            color: "greyscale.100",
            background: "danger.900",
        },
    },
    _disabled: {
        background: "secondary.300",
    },
};
const variantLink = {
    p: 0,
    height: "auto",
    color: "primary.500",
    _hover: {
        textDecoration: "none",
        color: { md: "primary.600" },
    },
    _active: { color: "primary.700" },
    _visited: { color: "greyscale.500" },
};
const variants = {
    primary: variantPrimary,
    secondary: variantSecondary,
    primaryAlt: variantPrimaryAlternative,
    subtle: variantSubtle,
    danger: variantDanger,
    link: variantLink,
};
const sizes = {
    xs: {
        fontSize: "sm",
        height: "auto",
        minH: 8,
        minW: 10,
        py: 2,
        px: 3,
        div: {
            boxSize: 4,
        },
        svg: {
            boxSize: 4,
        },
    },
    s: {
        fontSize: "sm",
        height: "auto",
        minH: 10,
        minW: 14,
        px: "18px",
        py: "10px",
        div: {
            boxSize: 5,
        },
        svg: {
            boxSize: 5,
        },
    },
    m: {
        fontSize: "md",
        px: 5,
        py: 3,
        height: "auto",
        minH: 12,
        minW: 16,
        div: {
            boxSize: 6,
        },
        svg: {
            boxSize: 6,
        },
    },
    l: {
        fontSize: "lg",
        height: "auto",
        minH: "60px",
        minW: "76px",
        px: 6,
        py: 4,
        div: {
            boxSize: 7,
        },
        svg: {
            boxSize: 7,
        },
    },
};
const defaultProps = {
    size: "m",
    variant: "primary",
};
const Button = {
    baseStyle,
    variants,
    sizes,
    defaultProps,
};
export default Button;
